import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { BILLING_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrApprovePage } from '@/features/dcrApprove/pages/DcrApprovePage';
import { dcrApproveSearchSchema } from '@/features/dcrApprove/types/dcrApprove.types';

export const Route = createFileRoute('/_auth/billing/dcr-approve')({
  beforeLoad: () => requirePermission(BILLING_PERMISSIONS.APPROVAL_VIEW),
  validateSearch: dcrApproveSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR Approve">
      <Suspense fallback={<PageLoader />}>
        <DcrApprovePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
